module.exports = __webpack_public_path__ + "static/00025.5a938809.jpg";